import { defineStore } from 'pinia'

interface TimerState {
  timeoutId: ReturnType<typeof setTimeout> | undefined
  isRefreshDialogOpen: boolean
}

export const refreshTimer = defineStore('refreshTimer', {
  state: (): TimerState => ({
    timeoutId: undefined,
    isRefreshDialogOpen: false,
  }),
  actions: {
    startTimer(duration: number) {
      clearTimeout(this.timeoutId)

      this.timeoutId = setTimeout(() => {
        this.isRefreshDialogOpen = true
      }, duration)
    },
    clearTimer() {
      clearTimeout(this.timeoutId)
    },
    closeDialogAndClearTimer() {
      clearTimeout(this.timeoutId)
      this.isRefreshDialogOpen = false
    },
  },
})
